import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100dvh;
  box-sizing: border-box;
  padding: 0;
  background: #e5e6e7;
}

.app-frame {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: none;
  margin: 0;
  overflow: hidden;
  background: #fff;
  border-radius: 0;
  box-shadow: none;
}

.desktop-sidebar {
  position: absolute;
  inset: 0 auto 0 0;
  z-index: 30;
  width: 224px;
  background: #fbfbfb;
}

.page-content {
  margin-left: 224px;
  min-width: 0;
  width: calc(100% - 224px);
  background: #e5e6e7;
}

:host ::ng-deep .sidebar-date {
  display: flex;
  flex-direction: column;
  padding: 30px 20px 8px;
}
:host ::ng-deep .date-number {
  font-size: 96px;
  font-weight: 850;
  line-height: 1;
  letter-spacing: -7px;
  color: #ff5b3b;
}
:host ::ng-deep .date-month {
  font-size: 18px;
  font-weight: 700;
  color: #3e3e3e;
  margin-top: 5px;
}
:host ::ng-deep wiz-component-nav-sidebar > div:not(.sidebar-date) {
  background: #fff !important;
  border-color: #ededed !important;
  border-radius: 0 !important;
  margin-top: 16px !important;
}
:host ::ng-deep wiz-component-nav-sidebar .bg-indigo-600 {
  background: #ff5b3b !important;
}
:host ::ng-deep wiz-component-nav-sidebar nav a {
  border-radius: 0;
}
:host ::ng-deep wiz-component-nav-sidebar nav a:hover {
  background: #fff0eb;
}
:host ::ng-deep wiz-component-nav-sidebar nav a[class*="bg-[#ff5b3b]"]:hover {
  background: #ef4d2c;
}
:host ::ng-deep wiz-component-nav-sidebar .text-indigo-600 {
  color: #e65031 !important;
}
:host ::ng-deep wiz-component-nav-sidebar nav {
  padding-bottom: 24px;
}
:host ::ng-deep wiz-component-nav-sidebar svg {
  flex-shrink: 0;
}
:host ::ng-deep .project-page {
  background: #f7f7f7;
}
:host ::ng-deep .cover {
  background: #e5e6e7 !important;
  color: #888 !important;
}
:host ::ng-deep .badge, :host ::ng-deep .intro, :host ::ng-deep .model-card, :host ::ng-deep .pdf-note, :host ::ng-deep .prototype {
  background: #fff2ed !important;
  border-color: #f1d9d2 !important;
  border-radius: 0 !important;
}
:host ::ng-deep .checked {
  background: #ff5b3b !important;
  border-color: #ff5b3b !important;
}
:host ::ng-deep .oral-lab button:not(.secondary) {
  background: #ff5b3b;
  border-color: #ff5b3b;
}
:host ::ng-deep .capstone-tabs button[aria-selected=true] {
  color: #ee5435;
  border-bottom-color: #ff5b3b;
}
:host ::ng-deep .method, :host ::ng-deep .experiment, :host ::ng-deep .chart-plan, :host ::ng-deep .model-card {
  border-radius: 0;
}
:host ::ng-deep button:focus-visible, :host ::ng-deep a:focus-visible {
  outline-color: #ff9d86;
}

@media (max-width: 1023px) {
  .page-content {
    margin-left: 0;
    width: 100%;
    padding-top: 44px;
  }
}
@media (max-width: 480px) {
  .page-content {
    padding-top: 42px;
  }
}
:host ::ng-deep .page-content [class*=bg-gradient-to-] {
  background: #e5e6e7 !important;
}
:host ::ng-deep .page-content [class*=max-w-] {
  max-width: none !important;
}
:host ::ng-deep .page-content [class*=mx-auto] {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
:host ::ng-deep .page-content [class*=rounded] {
  border-radius: 0 !important;
}
:host ::ng-deep .page-content .text-indigo-600, :host ::ng-deep .page-content .text-indigo-700, :host ::ng-deep .page-content .text-teal-600, :host ::ng-deep .page-content .text-teal-700 {
  color: #e65334 !important;
}
:host ::ng-deep .page-content .bg-indigo-50, :host ::ng-deep .page-content .bg-indigo-100 {
  background: #fff0eb !important;
}
:host ::ng-deep .page-content .bg-indigo-500, :host ::ng-deep .page-content .bg-indigo-600 {
  background: #ff5b3b !important;
}
:host ::ng-deep .page-content .capstone-tabs button[aria-selected=true] {
  color: #e65334 !important;
  border-bottom-color: #ff5b3b !important;
}
:host ::ng-deep .page-content .project-page a[href*="/algorithm/run"] {
  background: #ff5b3b !important;
  border-radius: 0 !important;
}

.app-frame.note-expanded .desktop-sidebar {
  display: none !important;
}
.app-frame.note-expanded .page-content {
  width: 100%;
  margin-left: 0;
  padding-top: 0;
}

/* Give only the Bike Link course its reference-style full-width workspace. */
:host ::ng-deep .app-frame:has(wiz-component-bike-link) .desktop-sidebar {
  display: none !important;
}

:host ::ng-deep .app-frame:has(wiz-component-bike-link) .page-content {
  width: 100% !important;
  margin-left: 0 !important;
  padding-top: 0 !important;
  background: #fff;
}

/* Keep all Bike Link tabs inside the same available course viewport. */
:host ::ng-deep .app-frame:has(wiz-component-bike-link) .page-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

:host ::ng-deep .app-frame:has(wiz-component-bike-link) .page-content > wiz-page-course {
  display: block;
  flex: 1 1 0;
  min-height: 0 !important;
  overflow: hidden;
}

:host ::ng-deep .app-frame:has(wiz-component-bike-link) wiz-component-bike-link {
  display: block;
  height: 100%;
  min-height: 0 !important;
}`],
})
export class LayoutSidebarComponent implements OnInit {
    public noteExpanded = false;

    @HostListener('window:ku-note-expansion', ['$event'])
    public async onNoteExpansion(event: CustomEvent<boolean>) {
        this.noteExpanded = event.detail;
        if (this.noteExpanded) await this.service.status.toggle('navbar', false);
        await this.service.render();
    }

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.status) {
            this.service.href('/login');
            return;
        }
        await this.service.render();
    }

    @HostListener('document:click')
    public async clickout() {
        if (!this.service.status.navbar) return;
        await this.service.status.toggle('navbar', false);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }
}

export default LayoutSidebarComponent;